module.exports = __webpack_public_path__ + "img/Pista_06.a653107a.png";